import React from 'react'

export default function InputWithoutLabel({object,content}) {
    return (
        <div className='d-flex gap-4 align-items-center justify-content-between'  style={{padding:"8px"}}>
            <input type='text' className='form-control' name={object.content === "" && content} />
        </div>
    )
}
